import React from "react";

const AutodepositBus = (props) => {
  const options = [
    {
      text: 'How do I set up Interac e-Transfer Autodeposit?',
      handler: props.actionProvider.AutodepositBus1,
      id: 1
    },
    {
      text: 'I’d like to understand more about the security around this. Where can I find that information?',
      handler: props.actionProvider.AutodepositBus2,
      id: 2
    },
    {
      text: 'I don’t want to use Interac e-Transfer Autodeposit anymore. How do I turn it off?',
      handler: props.actionProvider.AutodepositBus3,
      id: 3
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default AutodepositBus;